import { createStyles, makeStyles } from "@material-ui/core";

const styles = () =>
  createStyles({
    statusList: {
      alignItems: "flex-start",
      display: "flex",
      flexDirection: "column",
      gap: "4px"
    },
    hardwareListStatusList: {
      alignItems: "center",
      flexDirection: "row"
    },
    showMoreButton: {
      alignSelf: "flex-start",
      color: "#DB5C0E",
      fontSize: 11,
      fontWeight: 700,
      minWidth: "auto",
      padding: "2px 6px",
      textTransform: "none"
    },
    dialogContent: {
      maxHeight: "60vh",
      padding: 0
    },
    deviceList: {
      display: "flex",
      flexDirection: "column"
    },
    deviceRow: {
      alignItems: "center",
      borderBottom: "1px solid #ECEFF1",
      display: "flex",
      gap: "12px",
      padding: "12px 24px",
      "&:last-child": {
        borderBottom: "none"
      }
    },
    deviceIconWrap: {
      alignItems: "center",
      borderRadius: "50%",
      display: "inline-flex",
      flexShrink: 0,
      height: 36,
      justifyContent: "center",
      width: 36
    },
    deviceIcon: {
      fontSize: 20
    },
    deviceInfo: {
      minWidth: 0
    },
    deviceName: {
      color: "#263238",
      fontSize: 14,
      fontWeight: 600,
      overflowWrap: "anywhere"
    },
    deviceStatus: {
      fontSize: 12,
      fontWeight: 600,
      marginTop: 2,
      overflowWrap: "anywhere"
    }
  });

export default makeStyles(styles);
